import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { memo } from "react";

const useStyles = makeStyles(theme => ({
    EntryListRoot: {
        minHeight: '80vh',
        // '& .MuiGrid-item': {
        //     padding: theme.spacing(3),
        //     [theme.breakpoints.down('xs')]: {
        //         padding: theme.spacing(1)
        //     },
        // },
        paddingLeft: '30px',
        paddingRight: '30px',
        marginTop: '1rem',
        [theme.breakpoints.down('xl')]: {
            paddingLeft: '100px',
            paddingRight: '100px',
        },
        [theme.breakpoints.down('xl')]: {
            paddingLeft: '60px',
            paddingRight: '60px',
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: '10px',
            paddingRight: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '5px',
            paddingRight: '5px',
        },
    },
}));

export default memo(function EntryListRoot({ children, as = Box, className, ...props }) {
    const classes = useStyles();

    const AsComponent = as;

    return (
        <AsComponent className={`${classes.EntryListRoot} ${className}`} {...props}>
            {children}
        </AsComponent>
    )
});